import React from "react";

import "./underconstruction.css";

const UnderConstruction = () => (
  <>
    <h1 className="important">
      Pardon us for the mess. This part is currently under construction check
      back to see the wonderful things we have in store.
    </h1>
  </>
);

export default UnderConstruction;
